export const THEMES = {
  light: {
    name: 'Light',
    backgroundImage: null,
    overlayColor: null,
    mascotImage: '/images/general-mascot.png',
    openBookImage: '/images/general-open-book.png',
    closedBookImage: '/images/general-closed-book.png',
    cssVars: {
      '--bg':        '#EEF5EE',
      '--surf':      '#D9EDD9',
      '--stone':     '#8FBD8F',
      '--bark':      '#2E7D3E',
      '--ink':       '#0D2B12',
      '--accent':    '#238b45',
      '--sage':      '#52A96A',
      '--gold':      '#A8C96A',
      '--card-bg':   'rgba(255, 255, 255, 0.98)',
      '--hud-bg':    'transparent',
      '--hud-color': 'var(--stone)',
    },
    emojiSet: 'general',
  },
  dark: {
    name: 'Dark',
    backgroundImage: null,
    overlayColor: null,
    mascotImage: '/images/general-mascot.png',
    openBookImage: '/images/general-open-book.png',
    closedBookImage: '/images/general-closed-book.png',
    cssVars: {
      '--bg':        '#141414',
      '--surf':      '#1f1f1f',
      '--stone':     '#525252',
      '--bark':      '#a3a3a3',
      '--ink':       '#e5e5e5',
      '--accent':    '#6b6b6b',
      '--sage':      '#787878',
      '--gold':      '#c0c0c0',
      '--card-bg':   'rgba(20, 20, 20, 0.97)',
      '--hud-bg':    'transparent',
      '--hud-color': 'var(--bark)',
    },
    emojiSet: 'general',
  },
  rainy: {
    name: 'Rainy Window',
    backgroundImage: '/images/rainy-window.png',
    overlayColor: 'rgba(4, 14, 6, 0.35)',
    mascotImage: '/images/rainy-mascot.png',
    openBookImage: '/images/rainy-open-book.png',
    closedBookImage: '/images/rainy-closed-book.png',
    cssVars: {
      '--bg':        '#0e1f12',
      '--surf':      '#142a18',
      '--stone':     '#4a7a4a',
      '--bark':      '#6aaa7a',
      '--ink':       '#ccecd4',
      '--accent':    '#2d6b38',
      '--sage':      '#52a96a',
      '--gold':      '#9ecca4',
      '--card-bg':   'rgba(8, 20, 10, 0.96)',
      '--hud-bg':    'rgba(0, 0, 0, 0.28)',
      '--hud-color': 'rgba(255, 255, 255, 0.88)',
    },
    emojiSet: 'rainy',
  },
  cafe: {
    name: 'Cosy Cafe',
    backgroundImage: '/images/cosy-cafe.png',
    overlayColor: 'rgba(18, 8, 2, 0.35)',
    mascotImage: '/images/cafe-mascot.png',
    openBookImage: '/images/cafe-open-book.png',
    closedBookImage: '/images/cafe-closed-book.png',
    cssVars: {
      '--bg':        '#1e1208',
      '--surf':      '#2a1a08',
      '--stone':     '#7a5030',
      '--bark':      '#c89a60',
      '--ink':       '#fdf0d8',
      '--accent':    '#b5651d',
      '--sage':      '#d4956a',
      '--gold':      '#f0d090',
      '--card-bg':   'rgba(20, 10, 3, 0.96)',
      '--hud-bg':    'rgba(0, 0, 0, 0.28)',
      '--hud-color': 'rgba(255, 255, 255, 0.88)',
    },
    emojiSet: 'cafe',
  },
  quest: {
    name: 'Quest',
    backgroundImage: '/images/quest.png',
    overlayColor: 'rgba(5, 2, 14, 0.35)',
    mascotImage: '/images/quest-mascot.png',
    mascotSize: 220,
    openBookImage: '/images/quest-open-book.png',
    closedBookImage: '/images/quest-closed-book.png',
    cssVars: {
      '--bg':        '#120820',
      '--surf':      '#1a1030',
      '--stone':     '#5a3880',
      '--bark':      '#b090e0',
      '--ink':       '#e8d8ff',
      '--accent':    '#7B4EAB',
      '--sage':      '#9b78c8',
      '--gold':      '#d8b8ff',
      '--card-bg':   'rgba(14, 6, 28, 0.96)',
      '--hud-bg':    'rgba(0, 0, 0, 0.28)',
      '--hud-color': 'rgba(255, 255, 255, 0.88)',
    },
    emojiSet: 'quest',
  },
}
